import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import {
  TwilioAccountContext,
  TwilioAccountContextType,
} from "./TwilioAccountContext";

export const useTwilioAccount = (): TwilioAccountContextType => {
  const context = useContext(TwilioAccountContext);

  if (!context) {
    throw new HookOutOfContextError("useTwilioAccount", "TwilioAccountContext");
  }

  return context;
};
